<template>
  <div class="auth-tree">
    <el-tree
      ref="authTree"
      node-key="id"
      :data="list"
      :props="defaultProps"
      highlight-current
      show-checkbox
      :default-expanded-keys="selectAuth"
      :default-checked-keys="selectAuth"
      @check="handleNodeClick"
    >
      <span class="custom-tree-node" slot-scope="{ node }">
        <span>
          <span>{{ node.label }}</span>
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import Auth from '@/models/common/auth.js'
export default {
  // type: 1: 菜单权限
  // selectAuth: 所拥有的权限
  props: ['type', 'selectAuth'],

  data() {
    return {
      defaultProps: {
        children: "children",
        label: "name"
      },
      list: []
    }
  },

  created() {
    this.initAllMenuList()
  },

  methods: {
    initAllMenuList() {
      if (this.type == 1) {
        this.initAllMenuAuthTree()
      }
    },

    // 全部菜单权限
    initAllMenuAuthTree() {
      Auth.getAllMenuAuthTree().then(res => {
        if (res.success) {
          this.list = res.result
        } else {
          this.$message.error(res.message);
        }
      })
    },

    handleNodeClick() {
      let res = this.$refs.authTree.getCheckedNodes(true, true);
      this.$emit('getSetAuthList', res)
    }
  }
}
</script>

<style lang='scss'>
</style>
